module.exports = __webpack_public_path__ + "static/media/machine.new.b606806b.png";